export const ARRIVAL_LIST = 'ARRIVAL_LIST';
